import { render } from "./action-page.vue?vue&type=template&id=5a69604c&scoped=true&ts=true"
import script from "./action-page.ts?vue&type=script&lang=ts&external"
export * from "./action-page.ts?vue&type=script&lang=ts&external"

import "./action-page.less?vue&type=style&index=0&id=5a69604c&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a69604c"]])

export default __exports__